import React from 'react';
import Styled from 'styled';

import defaultStyles from './promo-box.scss';
import { Link } from 'react-router-dom';
import clovekSrc from './technik-heluz.jpg';
import logoSrc from './heluz-logo.jpeg';

interface Props {
    styles: typeof defaultStyles;
}

const PromoBox: React.FC<Props> = props => {
    const { styles } = props;

    return (
        <div className={styles.promoBox}>
            <div className={styles.promoAvatarWrapper}>
                <Link to='/catalog/vendor/technikheluz'>
                    <img className={styles.promoAvatar} srcSet={clovekSrc.srcSet} />
                </Link>
                <Link to='/catalog/vendor/technikheluz'>
                    <img className={styles.promoLogo} src={logoSrc} />
                </Link>
            </div>
            <div>
                <p>
                    Ako technický poradca v spoločnosti Heluz pomáham individuálnym stavebníkom a odborníkom kvalitne
                    zrealizovať alebo navrhnúť zdravý domov. Naše tehlové výrobky sú kvalitné, trvácne, majú výborné
                    tepelnoizolačné vlastnosti a sú dostupné za rozumnú cenu. Vieme, čo obnáša stavba domu. Poradíme,
                    spočítame spotrebu materiálu, dovezieme materiál na stavbu zadarmo a požičiame stavebné pomôcky.
                </p>
                <p>
                    Vyrábame tehly s rôznymi parametrami, stropy, preklady a komíny. Ponúkame tiež materiály na
                    murovanie - malty pre tenkú škáru, pre celoplošnú tenkú škáru, murovaciu penu a tepelnoizolačné
                    malty. Z našich výrobkov tak môže vzniknúť celá hrubá stavba. Myslíme aj na to, že množstvo ľudí
                    chce stavať svojpomocne. Neriešime tak len predaj tehál a ďalších produktov, ale poskytujeme tiež
                    poradenstvo a asistenčné služby. Veríme, že vďaka našim výrobkom a podpore dopadne stavba rodinného
                    domu presne podľa Vašich predstáv.
                </p>
                <p>HELUZ, to nie je len prvotriedna tehla, ale komplexný stavebný systém.</p>
                <p>Tento týždeň som Vám k dispozícii a rád Vám zodpoviem všetky Vaše otázky :)</p>
                <p className={styles.promoSignature}>Ing. Milan Komáromi</p>
            </div>
        </div>
    );
};

export default Styled(defaultStyles)(PromoBox);
